import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=632a9590&"
import script from "./auth.vue?vue&type=script&lang=js&"
export * from "./auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginAnim: require('/var/www/fbd-kte/assets/components/gui/brand/LoginAnim.vue').default,BrandIdentity: require('/var/www/fbd-kte/assets/components/gui/brand/BrandIdentity.vue').default,LogoLogin: require('/var/www/fbd-kte/assets/components/gui/brand/LogoLogin.vue').default,PortalFooter: require('/var/www/fbd-kte/assets/components/PortalFooter.vue').default})
